import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { FEATURES_MENU_ID, mobileProductsSectionMenuItems, PRODUCTS_MENU_ID, RESOURCES_MENU_ID, SectionsHeadersMenuItemsMapping, USE_CASES_MENU_ID } from "segments/desktop/header/layouts/base-header/base-header-service";
import { CONTACT_US_FROM_HEADER_PAGE_LINK, LOGIN_PAGE_LINK, PRICING_PAGE_LINK, ROOT_LINK } from "constants/links";
import { getMiniSitePricingPageLink } from "client/services/cluster-config-service/cluster-config-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withAbTests } from "/contexts/ab-tests-context";
import "@typeform/embed/build/css/popup.css";
import PictureComponent from "components/core/picture/picture-component";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import DownloadMobileAppComponent from "./download-mobile-app/download-mobile-app-component";
import LinkComponent from "./link/link-component";
import LinkWithSectionsMenuComponent from "./link-with-menu/link-with-sections-menu-component";
import { StyledHeaderMenuComponent } from "./header-menu-component.scss";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { useContactSalesTypeform } from "client/services/hooks/use-contact-cales-typeform";
const HeaderMenuComponent = (props)=>{
    const [openedMenuId, setOpenedMenuId] = useState(null);
    const { isMinisitePage, isMobileOrTabletBrowser, pageClusterConfig, useProductMiniSiteConfig, abTests, translate, isTypeformDisabled } = props;
    const SMALL_MONDAY_LOGO = "https://dapulse-res.cloudinary.com/image/upload/mobile_menu/Monday.png";
    const openLinksMenu = (menuId)=>{
        setOpenedMenuId(menuId);
    };
    const getPricingPageLink = ()=>{
        let minisitePricingPageLink = null;
        if (isMinisitePage) {
            minisitePricingPageLink = getMiniSitePricingPageLink(pageClusterConfig, {
                useProductMiniSiteConfig
            });
        }
        return minisitePricingPageLink || PRICING_PAGE_LINK;
    };
    const onMainLinkClick = (title)=>{
        fireGtmEvent(DataLayerEventTypes.CLICK_MAIN_NAV, {
            click_text: translate(title)
        });
    };
    const { displayTypeform } = useContactSalesTypeform({
        abTests,
        fallbackLink: CONTACT_US_FROM_HEADER_PAGE_LINK
    });
    const onContactSalesClicked = useCallback(()=>{
        !isTypeformDisabled && displayTypeform();
    }, [
        displayTypeform,
        isTypeformDisabled
    ]);
    const renderContactSalesMobileButton = ()=>{
        return /*#__PURE__*/ _jsx(LinkComponent, {
            title: "header.contactSales",
            onClickFunc: onContactSalesClicked,
            url: isTypeformDisabled ? CONTACT_US_FROM_HEADER_PAGE_LINK : null
        });
    };
    return /*#__PURE__*/ _jsxs(StyledHeaderMenuComponent, {
        className: "header-menu-mobile-component",
        children: [
            /*#__PURE__*/ _jsx(LinkWithSectionsMenuComponent, {
                id: PRODUCTS_MENU_ID,
                title: "header.products",
                links: mobileProductsSectionMenuItems,
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === PRODUCTS_MENU_ID
            }),
            /*#__PURE__*/ _jsx(LinkWithSectionsMenuComponent, {
                id: USE_CASES_MENU_ID,
                title: "header.teams",
                links: SectionsHeadersMenuItemsMapping[USE_CASES_MENU_ID],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === USE_CASES_MENU_ID
            }),
            /*#__PURE__*/ _jsx(LinkWithSectionsMenuComponent, {
                id: FEATURES_MENU_ID,
                title: "header.features",
                links: SectionsHeadersMenuItemsMapping[FEATURES_MENU_ID],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === FEATURES_MENU_ID
            }),
            /*#__PURE__*/ _jsx(LinkWithSectionsMenuComponent, {
                id: RESOURCES_MENU_ID,
                title: "header.resources",
                links: SectionsHeadersMenuItemsMapping[RESOURCES_MENU_ID],
                openLinksMenu: openLinksMenu,
                isOpen: openedMenuId === RESOURCES_MENU_ID
            }),
            /*#__PURE__*/ _jsx(LinkComponent, {
                title: "header.pricing",
                url: getPricingPageLink(),
                onClickFunc: ()=>onMainLinkClick("header.pricing")
            }),
            renderContactSalesMobileButton(),
            !isMobileOrTabletBrowser && /*#__PURE__*/ _jsx(LinkComponent, {
                title: "header.logIn",
                url: LOGIN_PAGE_LINK,
                onClickFunc: ()=>onMainLinkClick("header.logIn")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "download-mobile-app-component-wrapper",
                children: /*#__PURE__*/ _jsx(DownloadMobileAppComponent, {})
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "monday-link-wrapper",
                children: [
                    /*#__PURE__*/ _jsx(PictureComponent, {
                        src: SMALL_MONDAY_LOGO
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "monday-link-text-wrapper",
                        children: /*#__PURE__*/ _jsx(SecondaryButton, {
                            buttonText: translate("header.menuItem.backToHomePage"),
                            url: ROOT_LINK,
                            onClick: ()=>onMainLinkClick("logo")
                        })
                    })
                ]
            })
        ]
    });
};
export default withGenericConfig(withAbTests(HeaderMenuComponent));
